import React from 'react';
import useGetSimulationPricingsGroupHealthQuery from './hooks/useGetSimulationPricingsGroupHealthQuery.js';
import SimulationPricingGroupHealthForm from './SimulationPricingGroupHealthForm.jsx';
import { compose } from 'ramda';
import withMiddleFeatures from '@@viewCommonHoc/withMiddleFeatures.jsx';
import withGlobalData from '@@viewCommonHoc/withGlobalData.jsx';
import { Loading } from '@fasstech/middle-design-system';

const SimulationPricingGroupHealth = ({
  getMiddleText,
  getMiddleNumber,
  getMiddleBoolean,
  usersInformation
}) => {
  const {
    getSimulationPricingsGroupHealth,
    loading: isLoadingGetSimulationPricingsGroupHealth
  } = useGetSimulationPricingsGroupHealthQuery();

  if (isLoadingGetSimulationPricingsGroupHealth) return <Loading />;

  return (
    <SimulationPricingGroupHealthForm
      getPricings={getSimulationPricingsGroupHealth}
      getMiddleText={getMiddleText}
      getMiddleNumber={getMiddleNumber}
      getMiddleBoolean={getMiddleBoolean}
      usersInformation={usersInformation}
    />
  );
};

export default compose(
  withMiddleFeatures,
  withGlobalData
)(SimulationPricingGroupHealth);
